import { createStore } from '@aibees/shared/store';
import { PersonUpdatesStoreData as StoreData } from './types';

const usePersonUpdatesStore = createStore<StoreData>(
  'person-updates',
  (set) => ({
    emailsUpdateTriggered: false,
    setEmailsUpdateTriggered: (emailsUpdateTriggered) =>
      set({ emailsUpdateTriggered }),
    profileUpdateTriggered: false,
    setProfileUpdateTriggered: (profileUpdateTriggered) =>
      set({ profileUpdateTriggered }),
    analysisUpdateTriggered: false,
    setAnalysisUpdateTriggered: (analysisUpdateTriggered) =>
      set({ analysisUpdateTriggered }),
  })
);

export default usePersonUpdatesStore;
